export const actionValidator = (action) => {
	return (
		action &&
		typeof action.type === 'string' &&
		typeof action.iconName === 'string' &&
		(!action.label || typeof action.label === 'string') &&
		(action.badge === undefined ||
			typeof action.badge === 'string' ||
			typeof action.badge === 'number') &&
		(action.badgeStatusColor === undefined ||
			['success', 'warning', 'danger', 'info'].includes(action.badgeStatusColor)) &&
		(action.stacked === undefined || typeof action.stacked === 'boolean')
	)
}
